import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../security.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { EmailVerificationRequest } from '../models/email-verification-request.model';
import { CustomerProfile } from '../models/customer-profile.model';
import { DataService } from 'src/app/shared/data.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  standalone: false
})
export class VerifyEmailComponent implements OnInit {

  verificationCode: String = "";
  buttonSelected: string = "Register";

  user = {
    'loginId': '',
    'password': ''
  }

  verifyEmailReq = new EmailVerificationRequest();
  prof = new CustomerProfile();

  popMsg = {
    'title': '',
    'message': ''
  }

  navigateTo: String = "/login";


  constructor(
    public dataSvc: DataService,
    private securitySvc: SecurityService,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.user.loginId = params['loginId'];
      this.user.password = params['password'];
    });
  }

  verifyCode() {

    if (this.verificationCode === '') {
      this.popMsg.title = 'Verification Code Needed';
      this.popMsg.message = 'Please enter the verification code you received in the email';

      this.openDialog(this.popMsg);
      return false;
    }

    this.prof.loginId = this.user.loginId;
    this.prof.emailVerificationCode = this.verificationCode;
    this.securitySvc.verifyEmail(this.prof).subscribe(
      res => {
        console.log("Verification  : " + res);
        this.snackBar.open('Account created successfully!', 'OK', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['success-snackbar']
        });
        this.router.navigate([this.navigateTo]);
      },
      err => {
        this.popMsg.title = "Email verification failed";
        this.popMsg.message = "Email verification failed, please try again"
        console.log(err)
        this.openDialog(this.popMsg);
        return;

      })
  }

  resendVerificationCode() {
    this.prof.loginId = this.user.loginId;
    this.securitySvc.resendEmailVerificationCode(this.prof).subscribe(
      res => {
        this.popMsg.title = "Email verification code sent";
        this.popMsg.message = "Resent the email verification code, please check your email."
        this.openDialog(this.popMsg);
        return;
      },
      err => {
        this.popMsg.title = "Email verification code resend failed";
        this.popMsg.message = "Email verification code resend failed, please try again"
        console.log(err)
        this.openDialog(this.popMsg);
        return;

      })



  }

  cancel() {
  }


  openDialog(popupMessage) {
    //this.dialog.open(DialogWithCloseButtonComponent, {data: {title: 'Incomplete Form', message: 'Please enter firstname'}});
    this.dialog.open(DialogWithCloseButtonComponent, { data: popupMessage });
  }
}
